/* tslint:disable */
/* eslint-disable */
/**
 * SLM API used by SLM frontend
 * This is the specification of the backend APIs. The main purpose of this specification is to unify the API between SLM-backend and SLM-frontend. For localizations the Accept-Language header is used.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dl.mhs.bd3.se@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const NotificationType = {
    PRODUCT: '0',
    PRICE: '1',
    DISPLAY: '2',
    FLEXIBILITY: '3',
    SALES_SPACE_SIZE: '4',
    OVERFILL: '5',
    PLACEMENT: '6',
    EFFICIENT_REPL: '7',
    FILLING_RATE: '8',
    OTHER: '9',
    WAREHOUSE_LOCATION_REMOVED: '10',
} as const;
export type NotificationType = typeof NotificationType[keyof typeof NotificationType];


export function instanceOfNotificationType(value: any): boolean {
    for (const key in NotificationType) {
        if (Object.prototype.hasOwnProperty.call(NotificationType, key)) {
            if (NotificationType[key as keyof typeof NotificationType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function NotificationTypeFromJSON(json: any): NotificationType {
    return NotificationTypeFromJSONTyped(json, false);
}

export function NotificationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationType {
    return json as NotificationType;
}

export function NotificationTypeToJSON(value?: NotificationType | null): any {
    return value as any;
}

export function NotificationTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): NotificationType {
    return value as NotificationType;
}

